import { render, staticRenderFns } from "./newDealInfoDialog.vue?vue&type=template&id=22148642&scoped=true"
import script from "./newDealInfoDialog.vue?vue&type=script&lang=js"
export * from "./newDealInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22148642",
  null
  
)

export default component.exports